import React from 'react';
import { classes as newColorsBrandingClasses, st, } from './newColorsBranding.st.css.js';
import { classes as madeforClasses } from './madefor.st.css.js';
import { WixDesignSystemContext } from './context';
const WixDesignSystemProvider = ({ dataHook, className, as = 'span', children, theme, features = {}, ...rest }) => {
    const { newColorsBranding } = features;
    const newBrandingClass = newColorsBranding && newColorsBrandingClasses.root;
    return (React.createElement(WixDesignSystemContext.Provider, { value: { newBrandingClass, newColorsBranding } }, React.createElement(as, {
        ...rest,
        'data-hook': dataHook,
        'data-newcolorsbranding': newColorsBranding,
        className: st(className, newBrandingClass, madeforClasses.madefor, theme?.className),
    }, children)));
};
export default WixDesignSystemProvider;
//# sourceMappingURL=WixDesignSystemProvider.js.map